var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1527 19.0943H20.0686L19.6844 18.7238C21.0292 17.1595 21.8388 15.1286 21.8388 12.9194C21.8388 7.99314 17.8456 4 12.9194 4C7.99314 4 4 7.99314 4 12.9194C4 17.8456 7.99314 21.8388 12.9194 21.8388C15.1286 21.8388 17.1595 21.0292 18.7238 19.6844L19.0943 20.0686V21.1527L25.9554 28L28 25.9554L21.1527 19.0943ZM12.9194 19.0943C9.50257 19.0943 6.74443 16.3362 6.74443 12.9194C6.74443 9.50257 9.50257 6.74443 12.9194 6.74443C16.3362 6.74443 19.0943 9.50257 19.0943 12.9194C19.0943 16.3362 16.3362 19.0943 12.9194 19.0943Z",
    fill: "#8493AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.59386cfceff9c0ee69168f7b95090c6e.svg";
export { ForwardRef as ReactComponent };